/**
 * Check if `child` is a child of `parent`
 */
export function isChildOf(child: Node, parent: Node): boolean {
  if (child.parentNode === parent) {
    return true;
  }
  if (!child.parentNode) {
    return false;
  }
  return isChildOf(child.parentNode, parent);
}
